export const STORES = [
  {
    id: "blr-kor",
    name: "eBikeGo Store – Koramangala",
    city: "Bengaluru",
    address: "5th Block, 80 Feet Road, Koramangala, Bengaluru 560095",
    hours: "10:00 AM – 9:00 PM",
    status: "open",
    statusLabel: "Open today",
    services: ["Rent", "Buy", "Service"],
    phone: "+91 86556 92201",
    image: "https://customer-assets.emergentagent.com/job_bike-catalog-9/artifacts/h57rjfhq_01.png",
    lat: 12.9352,
    lng: 77.6245,
  },
  {
    id: "blr-ind",
    name: "eBikeGo Store – Indiranagar",
    city: "Bengaluru",
    address: "100 Feet Road, Indiranagar, Bengaluru 560038",
    hours: "10:00 AM – 9:00 PM",
    status: "open",
    statusLabel: "Open today",
    services: ["Rent", "Buy", "Service"],
    phone: "+91 86556 92201",
    image: "https://customer-assets.emergentagent.com/job_bike-catalog-9/artifacts/h57rjfhq_01.png",
    lat: 12.9784,
    lng: 77.6408,
  },
  {
    id: "blr-jpn",
    name: "eBikeGo Store – JP Nagar",
    city: "Bengaluru",
    address: "24th Main Rd, JP Nagar 6th Phase, Bengaluru 560078",
    hours: "10:00 AM – 9:00 PM",
    status: "open",
    statusLabel: "Open today",
    services: ["Rent", "Buy", "Service"],
    phone: "+91 86556 92201",
    image: "https://customer-assets.emergentagent.com/job_bike-catalog-9/artifacts/h57rjfhq_01.png",
    lat: 12.9078,
    lng: 77.5851,
  },
  {
    id: "blr-wht",
    name: "eBikeGo Store – Whitefield",
    city: "Bengaluru",
    address: "Brookefield Main Rd, Whitefield, Bengaluru 560066",
    hours: "10:00 AM – 8:00 PM",
    status: "closing",
    statusLabel: "Closes 8:00 PM",
    services: ["Rent", "Buy", "Service"],
    phone: "+91 86556 92201",
    image: "https://customer-assets.emergentagent.com/job_bike-catalog-9/artifacts/h57rjfhq_01.png",
    lat: 12.9698,
    lng: 77.7499,
  },
  {
    id: "mum-and",
    name: "eBikeGo Store – Andheri East (HQ)",
    city: "Mumbai",
    address: "Pramukh Plaza, Cardinal Gracious Rd, Andheri East, Mumbai 400099",
    hours: "10:00 AM – 9:00 PM",
    status: "open",
    statusLabel: "Open today",
    services: ["Rent", "Buy", "Service"],
    phone: "+91 86556 92201",
    image: "https://customer-assets.emergentagent.com/job_bike-catalog-9/artifacts/h57rjfhq_01.png",
    lat: 19.1136,
    lng: 72.8697,
  },
  {
    id: "mum-bnd",
    name: "eBikeGo Store – Bandra West",
    city: "Mumbai",
    address: "Linking Road, Bandra West, Mumbai 400050",
    hours: "11:00 AM – 9:00 PM",
    status: "open",
    statusLabel: "Open today",
    services: ["Buy", "Service"],
    phone: "+91 86556 92201",
    image: "https://customer-assets.emergentagent.com/job_bike-catalog-9/artifacts/h57rjfhq_01.png",
    lat: 19.0596,
    lng: 72.8295,
  },
  {
    id: "mum-pow",
    name: "eBikeGo Store – Powai",
    city: "Mumbai",
    address: "Hiranandani Gardens, Powai, Mumbai 400076",
    hours: "10:00 AM – 9:00 PM",
    status: "open",
    statusLabel: "Open today",
    services: ["Rent", "Buy", "Service"],
    phone: "+91 86556 92201",
    image: "https://customer-assets.emergentagent.com/job_bike-catalog-9/artifacts/h57rjfhq_01.png",
    lat: 19.1197,
    lng: 72.9056,
  },
  {
    id: "del-cp",
    name: "eBikeGo Store – Connaught Place",
    city: "Delhi",
    address: "Inner Circle, Connaught Place, New Delhi 110001",
    hours: "10:00 AM – 9:00 PM",
    status: "open",
    statusLabel: "Open today",
    services: ["Rent", "Buy", "Service"],
    phone: "+91 86556 92201",
    image: "https://customer-assets.emergentagent.com/job_bike-catalog-9/artifacts/h57rjfhq_01.png",
    lat: 28.6315,
    lng: 77.2167,
  },
  {
    id: "del-kar",
    name: "eBikeGo Store – Karol Bagh",
    city: "Delhi",
    address: "Pusa Road, Karol Bagh, New Delhi 110005",
    hours: "10:00 AM – 9:00 PM",
    status: "open",
    statusLabel: "Open today",
    services: ["Buy", "Service"],
    phone: "+91 86556 92201",
    image: "https://customer-assets.emergentagent.com/job_bike-catalog-9/artifacts/h57rjfhq_01.png",
    lat: 28.6519,
    lng: 77.1909,
  },
  {
    id: "pun-kor",
    name: "eBikeGo Store – Koregaon Park",
    city: "Pune",
    address: "North Main Road, Koregaon Park, Pune 411001",
    hours: "10:00 AM – 9:00 PM",
    status: "open",
    statusLabel: "Open today",
    services: ["Rent", "Buy", "Service"],
    phone: "+91 86556 92201",
    image: "https://customer-assets.emergentagent.com/job_bike-catalog-9/artifacts/h57rjfhq_01.png",
    lat: 18.5366,
    lng: 73.8939,
  },
  {
    id: "pun-ban",
    name: "eBikeGo Store – Baner",
    city: "Pune",
    address: "Baner Road, Baner, Pune 411045",
    hours: "10:00 AM – 9:00 PM",
    status: "open",
    statusLabel: "Open today",
    services: ["Buy", "Service"],
    phone: "+91 86556 92201",
    image: "https://customer-assets.emergentagent.com/job_bike-catalog-9/artifacts/h57rjfhq_01.png",
    lat: 18.5599,
    lng: 73.7762,
  },
  {
    id: "hyd-ban",
    name: "eBikeGo Store – Banjara Hills",
    city: "Hyderabad",
    address: "Road No. 12, Banjara Hills, Hyderabad 500034",
    hours: "10:00 AM – 9:00 PM",
    status: "open",
    statusLabel: "Open today",
    services: ["Rent", "Buy", "Service"],
    phone: "+91 86556 92201",
    image: "https://customer-assets.emergentagent.com/job_bike-catalog-9/artifacts/h57rjfhq_01.png",
    lat: 17.4126,
    lng: 78.4392,
  },
  {
    id: "hyd-gac",
    name: "eBikeGo Store – Gachibowli",
    city: "Hyderabad",
    address: "Financial District, Gachibowli, Hyderabad 500032",
    hours: "10:00 AM – 9:00 PM",
    status: "open",
    statusLabel: "Open today",
    services: ["Buy", "Service"],
    phone: "+91 86556 92201",
    image: "https://customer-assets.emergentagent.com/job_bike-catalog-9/artifacts/h57rjfhq_01.png",
    lat: 17.4399,
    lng: 78.3489,
  },
  {
    id: "che-ann",
    name: "eBikeGo Store – Anna Nagar",
    city: "Chennai",
    address: "2nd Avenue, Anna Nagar, Chennai 600040",
    hours: "10:00 AM – 9:00 PM",
    status: "open",
    statusLabel: "Open today",
    services: ["Rent", "Buy", "Service"],
    phone: "+91 86556 92201",
    image: "https://customer-assets.emergentagent.com/job_bike-catalog-9/artifacts/h57rjfhq_01.png",
    lat: 13.0850,
    lng: 80.2101,
  },
  {
    id: "che-tng",
    name: "eBikeGo Store – T. Nagar",
    city: "Chennai",
    address: "Usman Road, T. Nagar, Chennai 600017",
    hours: "10:00 AM – 9:00 PM",
    status: "open",
    statusLabel: "Open today",
    services: ["Buy", "Service"],
    phone: "+91 86556 92201",
    image: "https://customer-assets.emergentagent.com/job_bike-catalog-9/artifacts/h57rjfhq_01.png",
    lat: 13.0418,
    lng: 80.2341,
  },
];

export const CITIES = ["All Cities", "Bengaluru", "Mumbai", "Delhi", "Pune", "Hyderabad", "Chennai"];

// Map center per city (used for the Google Maps iframe)
export const CITY_CENTERS = {
  "All Cities": { lat: 22.5937, lng: 78.9629, zoom: 5, label: "India" },
  "Bengaluru":  { lat: 12.9716, lng: 77.5946, zoom: 11, label: "Bengaluru" },
  "Mumbai":     { lat: 19.0760, lng: 72.8777, zoom: 11, label: "Mumbai" },
  "Delhi":      { lat: 28.6139, lng: 77.2090, zoom: 11, label: "Delhi" },
  "Pune":       { lat: 18.5204, lng: 73.8567, zoom: 11, label: "Pune" },
  "Hyderabad":  { lat: 17.3850, lng: 78.4867, zoom: 11, label: "Hyderabad" },
  "Chennai":    { lat: 13.0827, lng: 80.2707, zoom: 11, label: "Chennai" },
};
